import { Direction, useMediaQuery, useTheme, Grid, Box } from '@mui/material';
import {
  CcfCalendarIcon,
  CcfHeader,
  CcfTabs,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { useSelector } from 'react-redux';
import { Calander } from '../../enums/calendar-tabs';
import { getApplicationDirection } from '../global.app.slice';
import SchedulerLargeView from './ccf-schedular-large-view';
import ccfAppSchedulerStyles from './ccf-app-schedule.styles';
import { CcfCommitmentsForm } from '../ccf-commitment/ccf-commitment-form';
import { getShowCommitmentFormState } from '../ccf-commitment/ccf-commitment.slice';
import { getNewCommitment } from '../ccf-inbox/ccf-inbox.slice';
import CcfScheduleNewCommitment from '../ccf-schedule-new-commitment/ccf-schedule-new-commitment';

/* eslint-disable-next-line */
export interface CcfAppScheduleProps {
  isfullView?: boolean;
}

interface CalendarTab {
  element: React.ReactElement;
  label: string;
  isActive: boolean;
}
/**
 * Schedule to be shown in CXone and IA. App scape has a different container
 * @example `<CcfAppSchedule />`
 */
export function CcfAppSchedule(props?: CcfAppScheduleProps) {
  const isNewCommitment = useSelector(getNewCommitment);
  const appDirection: Direction = useSelector(getApplicationDirection);
  const [translate] = useTranslator();
  const theme = useTheme();
  const isSmView = useMediaQuery(theme.breakpoints.down('xl'));
  const calendarTabs: CalendarTab[] = [
    {
      element: <SchedulerLargeView isfullView={props?.isfullView} />,
      isActive: true,
      label: translate(Calander.MY_SCHEDULE),
    },
  ];

  const activeTabs = calendarTabs.filter((tab) => tab.isActive);
  const schedulerStyles = ccfAppSchedulerStyles(theme, isSmView);
  const showCommitmentForm = useSelector(getShowCommitmentFormState);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isNewCommitment ? (
        <CcfScheduleNewCommitment />
      ) : (
        <Grid sx={schedulerStyles.calendarCardStyles}>
          {!isSmView && props?.isfullView && (
            <Grid sx={schedulerStyles.calendarHeaderSyles}>
              <CcfHeader
                LeftIcon={
                  <CcfCalendarIcon
                    color="primary"
                    viewBox="-3 -3 25 25"
                    fontSize="small"
                  />
                }
                headerText={translate('schedule')}
                RightIcon={false}
                direction={appDirection}
              />
            </Grid>
          )}
          {showCommitmentForm ? (
            <CcfCommitmentsForm isFullView={true} />
          ) : props?.isfullView ? (
            <CcfTabs
              currentTab={0}
              variant={CcfTabs.Variant.STANDARD}
              setCurrentTab={() => null}
            >
              {activeTabs.map((tab, index) => (
                <CcfTabs.TabPanel key={index} label={tab.label}>
                  <Box sx={schedulerStyles.tabContentSection}>
                    {tab.element}
                  </Box>
                </CcfTabs.TabPanel>
              ))}
            </CcfTabs>
          ) : (
            <>
              <CcfTypography sx={schedulerStyles.txtMySchedule}>
              {translate('mySchedule')}
              </CcfTypography>
              <Box sx={schedulerStyles.tabContentSection}>
                <SchedulerLargeView isfullView={props?.isfullView} />
              </Box>
            </>
          )}
        </Grid>
      )}
    </>
  );
}

export default CcfAppSchedule;
